export default "__VITE_ASSET__CSxY1yel__"